// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CreateAppointmentRequest } from './create-appointment-request';

/** See com.rev360.pms.api.controller.schedule.scheduleitem.CreateRescheduledAppointmentRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateRescheduledAppointmentRequest extends CreateAppointmentRequest {

	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: Boolean })
	copyInsuranceVerification!: boolean | null;

	@GandalfProperty({ designType: Number })
	employeeId!: number | null;

	@GandalfValidator({ notNull: { message: 'End Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfProperty({ designType: Number })
	originalAppointmentId!: number | null;

	@GandalfProperty({ designType: Boolean })
	overrideValidation!: boolean | null;

	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfProperty({ designType: Boolean })
	patientInitiated!: boolean | null;

	@GandalfProperty({ designType: Number })
	providerId!: number | null;

	@GandalfProperty({ designType: String })
	reason!: string | null;

	@GandalfArray(Number)
	recurrenceSlotIds!: number[] | null;

	@GandalfProperty({ designType: Number })
	roleId!: number | null;

	@GandalfProperty({ designType: Number })
	selectedSlotId!: number | null;

	@GandalfValidator({ notNull: { message: 'Start Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	startDate!: Date;

	@GandalfProperty({ designType: Number })
	subTypeId!: number | null;

	@GandalfValidator({ notNull: { message: 'Template is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	templateId!: number;

}
